import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltRecorderPlayerPlayButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-play-button-wireframe", __assign({}, transformedProps), children));
};
export default VeltRecorderPlayerPlayButtonWireframe;
